import Tools from '../../../tools.js';
import API from '../../../api';

import React, { useState, useEffect } from "react";
import { Button, Container, Row, Col, Form, Table } from 'react-bootstrap';
import { useMappedState, useDispatch } from 'redux-react-hook';
import Enums from '../../../enums';

export default function QuestTargetCustApp(props) {
    const [isFetched, setIsFetched] = useState(false);
    const [isInit, setIsInit] = useState(false);
    const [subStep, setSubStep] = useState(1);
    const [pi, setPi] = useState(props.pi || "");
    const [memList, setMemList] = useState([]);
    const [targetList, setTargetList] = useState([]);
    const items = useMappedState(state => state.items);
    const [genderFilter, setGenderFilter] = useState(0);
    const [isSending, setIsSending] = useState(false);
    // const tmpItems = useMappedState(state => state.tmpItems);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log("updated", isFetched);
        if (false == isFetched) {
            console.log(this);
            console.log(props);
            Tools.init();
            getData(onQuestionnaireUpdated);
        }
        setIsFetched(true);
    }, [isFetched]);

    function getData() {
        var tmpData = {
            pi: pi
        };
        API.GetQuestionnaire(tmpData).
            then(onDataUpdated);
        var tmpData = {
            ty: 0
        };
        API.GetCustomerIncubators(tmpData).
            then(onMemListUpdated);
    }

    function onTest() {
        console.log("onTest");
        // 0 : 客戶的測試帳號
        // 1 : 指定名單
        // 2 : 依照會員資料條件 (同MemberFilter)
        // 3 : 孵化器編號(僅孵化器客戶可使用)
        var tmpData = {
            id: pi,
            ty: 0 //(items == null || 0 == items.length) ? 0 : 1
        };
        API.CustomerSendProject(tmpData, { members: [] })
            .then(checkResult)
    }
    function checkResult(data) {
        // console.log(data);
        if (data && data.responseData) {
            try {
                alert(data.responseData.msg);
            } catch (e) {
                alert("update error");
                console.warn(e.stack);
            }
        }
    }

    function onSend() {
        console.log("onSend");
        // console.log(tmpItems);
        var tmpData = {
            id: pi,
            ty: 1 //(items == null || 0 == items.length) ? 0 : 1
        };
        let body = {
            members: targetList.map(x => ({ "ac": x }))
        }
        console.log(body);
        setIsSending(true);
        API.CustomerSendProject(tmpData, body)
            .then(checkSendResult)
    }
    function checkSendResult(data) {
        // console.log(data);
        setIsSending(false);
        if (data && data.responseData) {
            try {
                alert(data.responseData.msg);
                //code: "22000"
                //msg: "操作成功 : 已推送給 1 位會員"
                if (data.responseData.code == "22000") {
                    props.onFinish();
                }
            } catch (e) {
                alert("update error");
                console.warn(e.stack);
            }
        }
    }

    function onQuestionnaireUpdated(data) {
        if (data && data.response
            && data.response.status == 200 && data.responseData) {
            dispatch({ type: "UPDATE_ITEM", data: { ...data, items: data.responseData } });
        } else {
            dispatch({ type: "UPDATE_ITEM", data: { pid: pi, items: [] } });
        }
        setIsInit(true);
    }

    function onMemListUpdated(data) {
        console.log(data);
        if (data && data.response
            && data.response.status == 200 && data.responseData
            && data.responseData.data && data.responseData.data.length > 0) {
            setMemList(data.responseData.data)
            try {
                let tmp = [];
                data.responseData.data.forEach((inq) => {
                    inq.members.forEach((mem) => {
                        tmp.push(mem.accessId)
                    })
                })
                setTargetList(tmp);
            } catch (e) {
                console.log(e.stack);
            }
        } else {
            alert("無會員資料");
        }
    }

    function onDataUpdated(data) {
        if (data && data.response
            && data.response.status == 200 && data.responseData) {
            dispatch({ type: "UPDATE_ITEM", data: { pid: pi, items: data.responseData } });
        } else {
            dispatch({ type: "UPDATE_ITEM", data: { pid: pi, items: [] } });
        }
        setIsInit(true);
    }

    function handlerGender(data) {
        console.log(data);
        setGenderFilter(data);
        try {
            let tmp = [];
            if (data == 0) {
                memList.forEach((inq) => {
                    inq.members.forEach((mem) => {
                        tmp.push(mem.accessId)
                    })
                })
            } else {
                memList.forEach((inq) => {
                    inq.members.forEach((mem) => {
                        if (mem.gender == data) tmp.push(mem.accessId)
                    })
                })
            }
            setTargetList(tmp);
        } catch (e) {
            console.log(e.stack);
        }
    }

    function getAge(birthdayStr) {
        //1989-10-04
        try {
            let y = birthdayStr.substr(0, 4),
                m = parseInt(birthdayStr.substr(5, 2)) - 1,
                d = birthdayStr.substr(8, 2);
            let diff = new Date() - new Date(y, m, d);
            return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
        } catch (e) {
            console.warm(e.stack);
        }
    }

    function onSelectTarget(id) {
        let tmp = [...targetList];
        let idx = tmp.indexOf(id)
        if (idx >= 0) {
            tmp.splice(idx, 1);
        } else {
            tmp.push(id);
        }
        setTargetList(tmp);
    }

    function onClickSelectAllSwitch() {
        try {
            let tmp = [];
            if (genderFilter == 0) {
                memList.forEach((inq) => {
                    inq.members.forEach((mem) => {
                        tmp.push(mem.accessId)
                    })
                })
            } else {
                memList.forEach((inq) => {
                    inq.members.forEach((mem) => {
                        if (mem.gender == genderFilter) tmp.push(mem.accessId)
                    })
                })
            }
            if (targetList.length == tmp.length) {
                setTargetList([]);
            } else {
                setTargetList(tmp);
            }
        } catch (e) {
            console.log(e.stack);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        // let check = true;
        // alert(`${kindOfStand}`);
        if (targetList.length > 0) {
            let tmp = { members: targetList.map(x => ({ "ac": x })) };
            setSubStep(2);
            props.onNextStep(tmp);
        } else {
            alert("請至少選擇一位會員");
        }
    }

    function render4() {
        let tbody = [];
        // console.log(memList);
        if (memList) {
            let i = 1;
            memList.forEach((tmp, index) => {
                // console.log(index, tmp);
                if (tmp && tmp.members) {
                    tmp.members.forEach((mem, memIndex) => {
                        // console.log(i, memIndex, mem.gender, genderFilter);
                        if (genderFilter == 0 || genderFilter == mem.gender) {
                            tbody.push(<tr key={i}>
                                <td>
                                    <Form.Group controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" checked={targetList ? targetList.indexOf(mem.accessId) >= 0 : false} onChange={() => onSelectTarget(mem.accessId)} />
                                    </Form.Group>
                                </td>
                                <td>{i}</td>
                                <td>{Enums.E_GENDER_TEXT[mem.gender]}</td>
                                <td>{getAge(mem.birthday)}</td>
                            </tr>);
                            i++;
                        }
                    });
                }

            });
        }
        return (
            <Container className="App mb-50">
                <Form onSubmit={handleSubmit}>
                    {/* <Form.Group controlId="formBasicEmail">
                        <Form.Label>調查份數</Form.Label>
                        <Form.Control type="text" placeholder="100" />
                        <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
                        </Form.Text>
                    </Form.Group> */}

                    <Form.Group controlId="gender">
                        <Form.Label>性別設定</Form.Label>
                        <Form.Check
                            value="0"
                            type="radio"
                            label="不篩選"
                            onChange={() => handlerGender(0)}
                            checked={genderFilter == 0}
                        />
                        <Form.Check
                            value="1"
                            type="radio"
                            label="男"
                            onChange={() => handlerGender(1)}
                            checked={genderFilter == 1}
                        />
                        <Form.Check
                            value="2"
                            type="radio"
                            label="女"
                            onChange={() => handlerGender(2)}
                            checked={genderFilter == 2}
                        />
                    </Form.Group>

                    <Form.Group controlId="selectAllSwitch">
                        <Button onClick={onClickSelectAllSwitch}>全選/全不選切換</Button>
                    </Form.Group>

                    <label>直接設定派送對象</label>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>編號</th>
                                <th>性別</th>
                                <th>年齡</th>
                            </tr>
                        </thead>
                        <tbody>{tbody}</tbody>
                    </Table>


                    <Button variant="primary" onClick={handleSubmit}>
                        確定
                    </Button>
                </Form>
            </Container>
        );
    }

    function render5() {
        return (
            <Container className="App mb-50">
                <Row>
                    <Col xs={12}><label>{"題目數: " + items.length}</label></Col>
                    <Col xs={12}><label>無其他設定</label></Col>
                    <Col xs={12}><label>預計發給{targetList.length}位粉絲</label></Col>
                </Row>
                <Row>
                    <Col className="col text-left">
                        <Button onClick={onTest}>開始使用手機測試</Button>
                    </Col>
                </Row>
                <Row>
                    <Col className="mt-4 col text-center">
                        <Button variant="danger" onClick={onSend}>{isSending ? "上架中, 請稍候.." : "確定問卷上架"}</Button>
                    </Col>
                </Row>
            </Container>
        );
    }

    function render() {
        // console.log("[!!]", items);
        if (null == items) {
            if (isInit == true) {
                return <div>No Data</div>
            }
            return <div>loading...</div>
        } else {
            if (subStep == 1) {
                return render4()
            } else {
                return render5()
            }
        }
    }
    return render();
}
